// extracted by mini-css-extract-plugin
module.exports = {"links":"packages-components-NavComponent-Menu-style__links--2a_LO","overlay":"packages-components-NavComponent-Menu-style__overlay--2v0em"};